export const LS_KEY_LIST_LAYOUT = 'switch'
